module.exports = __webpack_public_path__ + "prod/1.42.2/img/bankeysPC-goodsImg.8312bf00.png";